// @vendors
const { Promise } = require('es6-promise');

// @utils
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const SanitizeHelper = require('utilities/sanitizeHelper');

// @actions
const GetResultsListAction = require('actions/brokerAdvancedSearch/brokerAdvancedSearchGetResultsListRequest');

// @constants
const {
    TYPE_WARRANTS,
    BROKER_ADVANCED_SEARCH_VIEW_ADVANCED_SEARCH_TAB,
    BROKER_SIMPLE_SEARCH_PAGE_NUM
} = require('constants/index');

const {
    BROKER_SIMPLE_SEARCH_REQUEST,
    BROKER_SIMPLE_SEARCH_SUCCESS,
    BROKER_SIMPLE_SEARCH_FAILURE,
    BROKER_SIMPLE_SEARCH_CLEAR,
    BROKER_SIMPLE_SEARCH_TOGGLE_MODAL_FILTER,
    BROKER_SIMPLE_SEARCH_SELECT_FILTER,
    BROKER_SIMPLE_SEARCH_APPLY_FILTER,
    BROKER_SIMPLE_SEARCH_CLEAR_FILTERS,
    BROKER_SIMPLE_SEARCH_CHANGE_SEARCH_INPUT,
    BROKER_ADVANCED_SEARCH_FIELD_CHANGE,
    BROKER_ADVANCED_SEARCH_CHANGE_TAB,
    BROKER_SIMPLE_SPECIFIC_SEARCH_SUCCESS
} = require('constants/actionTypes');

const changeTab = (tab) => {
    return {
        type: BROKER_ADVANCED_SEARCH_CHANGE_TAB,
        payload: { tab }
    };
};

const handleFieldChange = (field, value) => {
    return {
        type: BROKER_ADVANCED_SEARCH_FIELD_CHANGE,
        payload: {
            field,
            value
        }
    };
};

const seeMore = (search, type) => (dispatch, getState) => {
    dispatch(handleFieldChange('activeProduct', type));

    if (type !== TYPE_WARRANTS) {
        dispatch(handleFieldChange('term', search));
    }

    const searchState = getState().brokerAdvancedSearch;
    const activeProduct = searchState.getIn(['activeProduct']);
    const selectedValues = searchState.getIn(['selectedValues', activeProduct]);

    GetResultsListAction(selectedValues, activeProduct)(dispatch);
    dispatch(changeTab(BROKER_ADVANCED_SEARCH_VIEW_ADVANCED_SEARCH_TAB));
};

const changeSearchInput = (search) => (dispatch) => {
    dispatch({
        type: BROKER_SIMPLE_SEARCH_CHANGE_SEARCH_INPUT,
        payload: {
            search
        }
    });
};

const searchProductsRequest = (pageNum = 1) => {
    return {
        type: BROKER_SIMPLE_SEARCH_REQUEST,
        payload: {
            pageNum
        }
    };
};

const searchProductsSuccess = (response) => {
    return {
        type: BROKER_SIMPLE_SEARCH_SUCCESS,
        payload: {
            data: response
        }
    };
};

const searchProductsFailure = (response) => {
    return {
        type: BROKER_SIMPLE_SEARCH_FAILURE,
        payload: {
            data: response
        }
    };
};

const searchProducts = (term, quantity) => (dispatch) => {
    return new Promise(() => {
        const encodedTerm = encodeURIComponent(SanitizeHelper.encodeData(term));
        const url = apiURLBuilder.getURL('brokerSimpleSearch', { term: encodedTerm });
        const requestData = {
            query: {
                pageNum: BROKER_SIMPLE_SEARCH_PAGE_NUM,
                pageSize: quantity
            }
        };

        dispatch(searchProductsRequest());

        APIGet(dispatch, url, requestData).then(
            response => dispatch(searchProductsSuccess(response)),
            error => dispatch(searchProductsFailure(error, term))
        );
    });
};

const searchSpecificProductsSuccess =  (response, productType, activeMarket, pageNum) => {
    return {
        type: BROKER_SIMPLE_SPECIFIC_SEARCH_SUCCESS,
        payload: {
            data: response,
            productType,
            activeMarket,
            pageNum
        }
    };
};

const searchSpecificProducts = (term, quantity, pageNum=BROKER_SIMPLE_SEARCH_PAGE_NUM, productType='', activeMarket) => (dispatch) => {
    return new Promise(() => {
        const encodedTerm = encodeURIComponent(SanitizeHelper.encodeData(term));
        const url = apiURLBuilder.getURL('brokerSimpleSearch', { term: encodedTerm });
        const requestData = {
            query: {
                pageNum,
                pageSize: quantity
            }
        };

        if (!!productType) {
            requestData.query.products = productType.toUpperCase();
        }

        dispatch(searchProductsRequest(pageNum));
        APIGet(dispatch, url, requestData).then(
            response =>{
                dispatch(searchSpecificProductsSuccess(response, productType, activeMarket, pageNum));
            },
            error => dispatch(searchProductsFailure(error, term))
        );
    });
};

const clearResults = () => (dispatch) => {
    dispatch({
        type: BROKER_SIMPLE_SEARCH_CLEAR,
        payload: {}
    });
};

const toggleModalFilter = () => (dispatch) => {
    dispatch({
        type: BROKER_SIMPLE_SEARCH_TOGGLE_MODAL_FILTER,
        payload: {}
    });
};

const selectFilter = (filter) => (dispatch) => {
    dispatch({
        type: BROKER_SIMPLE_SEARCH_SELECT_FILTER,
        payload: { filter }
    });
};

const applyFilter = () => (dispatch) => {
    dispatch({
        type: BROKER_SIMPLE_SEARCH_APPLY_FILTER,
        payload: {}
    });
};

const clearFilters = () => (dispatch) => {
    dispatch({
        type: BROKER_SIMPLE_SEARCH_CLEAR_FILTERS,
        payload: {}
    });
};

module.exports = {
    seeMore,
    changeSearchInput,
    searchProducts,
    clearResults,
    toggleModalFilter,
    selectFilter,
    applyFilter,
    clearFilters,
    searchSpecificProducts
};
